(function () {
  'use strict';

  if (window.__psiConfiguredSheetV12) return;
  window.__psiConfiguredSheetV12 = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  ready(function () {
    var modal = document.getElementById('psi-sheet-modal');
    var frame = document.getElementById('psi-sheet-preview-frame');
    var customer = document.getElementById('psi-sheet-customer');
    var details = document.getElementById('psi-sheet-full-details');
    var closeBtn = document.getElementById('psi-sheet-close');
    var printBtn = document.getElementById('psi-sheet-print');
    var downloadBtn = document.getElementById('psi-sheet-download');
    var status = document.getElementById('psi-sheet-status');

    if (!modal || !frame || !customer || !details || !closeBtn || !printBtn || !downloadBtn) {
      console.error('[PSI Product Sheet] UI was not found.');
      return;
    }

    console.info('[PSI Product Sheet] v12 ready');
    var lastFocused = null;

    function visible(el) {
      if (!el) return false;
      var style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && (el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    function text(value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }

    function esc(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }

    function firstText(selectors) {
      for (var i = 0; i < selectors.length; i++) {
        var nodes = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < nodes.length; j++) {
          if (!visible(nodes[j])) continue;
          var v = text(nodes[j].textContent);
          if (v) return v;
        }
      }
      return '';
    }

    function title() {
      return firstText(['h1.product-single__title', '.product-single__title', 'h1[itemprop="name"]']) || document.title.split('|')[0].trim();
    }

    function sku() {
      var v = firstText(['#product-sku', '.variant-sku']);
      return v.replace(/^SKU\s*:\s*/i, '');
    }

    function moneyValues(value) {
      return text(value).match(/\$\s?[\d,]+(?:\.\d{1,2})?/g) || [];
    }

    function livePrice() {
      var blocks = document.querySelectorAll('.product-single__price, [data-product-price-root]');
      for (var i = 0; i < blocks.length; i++) {
        if (!visible(blocks[i])) continue;
        var vals = moneyValues(blocks[i].textContent);
        if (vals.length) return vals[0].replace(/\s/g, '');
      }
      return firstText(['[data-product-price]']);
    }

    function comparePrice() {
      var nodes = document.querySelectorAll('[data-compare-price], .compare_price, s');
      for (var i = 0; i < nodes.length; i++) {
        if (!visible(nodes[i])) continue;
        var vals = moneyValues(nodes[i].textContent);
        if (vals.length) return vals[0].replace(/\s/g, '');
      }
      return '';
    }

    function heroImage() {
      var selectors = [
        '.product-single__media-wrapper img', '.product-single__photo img',
        'img.product-single__photo', '#productPhotoImg', '.product-image-content img'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var imgs = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < imgs.length; j++) {
          if (!visible(imgs[j])) continue;
          var src = imgs[j].currentSrc || imgs[j].src || imgs[j].getAttribute('data-src') || '';
          if (src && src.indexOf('data:image') !== 0) return src;
        }
      }
      return '';
    }

    function logoImage() {
      var selectors = [
        'header .site-header__logo-image img', 'header .header-logo img',
        'header .logo img', '.site-header .logo img', 'header img[alt*="PSI" i]'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var img = document.querySelector(selectors[i]);
        if (img) return img.currentSrc || img.src || '';
      }
      return '';
    }

    function conciseLabel(el) {
      var label = '';
      if (el.id) {
        try {
          var exact = document.querySelector('label[for="' + CSS.escape(el.id) + '"]');
          if (exact) label = text(exact.textContent);
        } catch (e) {}
      }
      if (label && label.length < 120) return label;

      var node = el;
      for (var depth = 0; depth < 5 && node; depth++, node = node.parentElement) {
        var candidates = node.querySelectorAll('legend, label, .form__label, [class*="option-label"], [class*="option_title"], [class*="option-title"], h2, h3, h4, strong');
        for (var c = 0; c < candidates.length; c++) {
          if (candidates[c] === el || candidates[c].contains(el)) continue;
          var t = text(candidates[c].textContent);
          if (t && t.length <= 100 && !/^add to cart$/i.test(t)) return t.replace(/\*+$/g, '').trim();
        }
        var prev = node.previousElementSibling;
        if (prev) {
          var p = text(prev.textContent);
          if (p && p.length <= 100) return p;
        }
      }
      return text(el.getAttribute('aria-label') || el.name || 'Option').replace(/^properties\[|\]$/g, '').replace(/_/g, ' ');
    }

    function optionPrice(value) {
      if (/no\s*(thanks|charge)/i.test(value)) return 'No charge';
      var m = text(value).match(/\+\s*\$\s?[\d,]+(?:\.\d{1,2})?/i);
      return m ? m[0].replace(/\s/g, '') : '';
    }

    function optionValue(value) {
      return text(value)
        .replace(/\s*\(\s*\+?\s*\$[\d,]+(?:\.\d{1,2})?\s*\)\s*$/i, '')
        .replace(/\s*\+\s*\$[\d,]+(?:\.\d{1,2})?\s*$/i, '')
        .trim();
    }

    function collectOptions() {
      var rows = [];
      var seen = Object.create(null);

      function add(label, value) {
        label = text(label);
        value = text(value);
        if (!value || value === 'Default Title') return;
        var hay = (label + ' ' + value).toLowerCase();
        if (/currency|country\/region|sort by|search|quantity|newsletter/.test(hay)) return;
        var key = (label + '|' + value).toLowerCase();
        if (seen[key]) return;
        seen[key] = true;
        rows.push({ label: label || 'Option', value: optionValue(value) || value, price: optionPrice(value) });
      }

      // Mageworx APO currently renders the PSI configuration controls as normal selects.
      // Read them only when visible, at click time, after the app has finished loading.
      Array.prototype.forEach.call(document.querySelectorAll('select'), function (sel) {
        if (!visible(sel) || sel.disabled) return;
        if (sel.closest('#psi-sheet-modal, header, footer, .site-header, .site-footer, .facets, .collection-sorting')) return;
        var opt = sel.options && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
        if (!opt) return;
        add(conciseLabel(sel), opt.textContent || opt.value);
      });

      Array.prototype.forEach.call(document.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked'), function (input) {
        if (input.closest('#psi-sheet-modal, header, footer')) return;
        var label = conciseLabel(input);
        var choice = input.value;
        if (input.id) {
          try {
            var exact = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
            if (exact) choice = text(exact.textContent) || choice;
          } catch (e) {}
        }
        add(label, choice || 'Selected');
      });

      return rows;
    }

    function descriptionHtml() {
      var src = document.querySelector('.product-single__description #tab-1') || document.querySelector('#tab-1') || document.querySelector('.product-single__description');
      if (!src) return '';
      var clone = src.cloneNode(true);
      Array.prototype.forEach.call(clone.querySelectorAll('script, style, iframe, form, button, input, select, textarea, .jdgm-widget, [id*="judge"], [class*="review"]'), function (el) { el.remove(); });
      Array.prototype.forEach.call(clone.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });

      // Keep wide product comparison tables in the brochure. They are given a dedicated
      // compact print treatment so the full chart can be included on A4 instead of being omitted.
      Array.prototype.forEach.call(clone.querySelectorAll('table'), function (table) {
        var maxCols = 0;
        Array.prototype.forEach.call(table.rows || [], function (row) {
          maxCols = Math.max(maxCols, row.cells ? row.cells.length : 0);
        });
        if (maxCols > 7) {
          table.classList.add('psi-sheet-wide-table');

          // Mark the actual header row explicitly. Using CSS tr:first-child here is unsafe
          // because the first row in BOTH <thead> and <tbody> matches :first-child,
          // which made the first data row (e.g. Sediments) look like a giant blue header in print.
          var wideRows = Array.prototype.slice.call(table.rows || []);
          var headerRow = null;
          for (var wr = 0; wr < wideRows.length; wr++) {
            var cells = Array.prototype.slice.call(wideRows[wr].cells || []);
            if (cells.some(function (cell) { return String(cell.tagName).toLowerCase() === 'th'; })) {
              headerRow = wideRows[wr];
              break;
            }
          }
          if (!headerRow && wideRows.length) headerRow = wideRows[0];
          wideRows.forEach(function (row) {
            row.classList.add(row === headerRow ? 'psi-sheet-wide-header-row' : 'psi-sheet-wide-data-row');
          });

          var wrap = document.createElement('div');
          wrap.className = 'psi-sheet-wide-table-wrap';
          table.parentNode.insertBefore(wrap, table);
          wrap.appendChild(table);
        } else {
          table.classList.add('psi-sheet-compact-table');
        }
      });

      Array.prototype.forEach.call(clone.querySelectorAll('img'), function (img) {
        img.classList.add('psi-sheet-detail-image');
        if (img.parentElement && img.parentElement.children.length <= 3) {
          img.parentElement.classList.add('psi-sheet-image-block');
        }
      });

      return clone.innerHTML;
    }

    function auDate() {
      try { return new Intl.DateTimeFormat('en-AU', { day: '2-digit', month: 'long', year: 'numeric' }).format(new Date()); }
      catch (e) { return new Date().toLocaleDateString('en-AU'); }
    }

    function printCss() {
      return '@page{size:A4 portrait;margin:10mm}*{box-sizing:border-box}html,body{margin:0;padding:0;background:#fff;color:#172839;font-family:Arial,Helvetica,sans-serif;-webkit-print-color-adjust:exact;print-color-adjust:exact}body{font-size:10.5pt;line-height:1.45}.sheet{width:190mm;max-width:190mm;margin:0 auto}.hdr{display:flex;align-items:center;justify-content:space-between;gap:20px;padding:0 0 7mm;border-bottom:2px solid #0e68b9;break-inside:avoid;page-break-inside:avoid}.brand img{display:block;max-width:58mm;max-height:17mm}.brand strong{font-size:19pt;color:#0e68b9}.meta{text-align:right}.meta strong{display:block;color:#0e68b9;font-size:11pt}.meta span{color:#687887;font-size:9pt}.hero{display:grid;grid-template-columns:44% 56%;gap:8mm;padding:9mm 0 7mm;break-inside:avoid;page-break-inside:avoid}.photo{min-height:90mm;display:flex;align-items:center;justify-content:center;background:#f3f7fa;border:1px solid #d9e4ec;border-radius:3mm;overflow:hidden}.photo img{display:block;max-width:100%;max-height:100mm;object-fit:contain}.eyebrow{color:#0e68b9;font-size:9pt;font-weight:700;text-transform:uppercase;letter-spacing:.08em;margin-bottom:2mm}h1{font-size:22pt;line-height:1.12;margin:0 0 3mm;color:#123f6e}.sku{color:#627384;margin-bottom:4mm}.prepared{border-top:1px solid #d9e4ec;padding-top:4mm;margin-top:4mm}.prepared span{display:block;font-size:8.5pt;color:#708191}.prepared strong{display:block;font-size:13pt;color:#24394d;margin-top:1mm}.price{margin-top:5mm;padding:5mm;background:#eef6fd;border-left:4px solid #0e68b9;border-radius:2mm;break-inside:avoid;page-break-inside:avoid}.price>span{display:block;color:#53697e;font-size:9pt;font-weight:700;text-transform:uppercase}.price strong{font-size:25pt;color:#0e68b9}.compare{margin-left:3mm;color:#8090a0;text-decoration:line-through}.price small{display:block;color:#5f7181;font-size:8pt}.ttl{font-size:14pt;font-weight:700;color:#123f6e;padding-bottom:2mm;margin-bottom:3mm;border-bottom:1px solid #cfdde8;break-after:avoid;page-break-after:avoid}.cfg{break-inside:avoid;page-break-inside:avoid;margin-bottom:8mm}.cfg table{width:100%;border-collapse:collapse;table-layout:fixed}.cfg tr{break-inside:avoid;page-break-inside:avoid}.cfg th,.cfg td{padding:3mm 3.5mm;border-bottom:1px solid #e1e8ee;vertical-align:top}.cfg th{width:28%;text-align:left;color:#2e455b;background:#f7f9fb}.cfg td:nth-child(2){width:54%}.op{width:18%;text-align:right;font-weight:700;color:#0e68b9;white-space:nowrap}.details{margin-top:7mm}.details h1{font-size:18pt}.details h2{font-size:15pt;color:#123f6e;margin:8mm 0 3mm;break-after:avoid;page-break-after:avoid}.details h3{font-size:12.5pt;color:#123f6e;margin:6mm 0 2mm;break-after:avoid;page-break-after:avoid}.details img{display:block;max-width:100%!important;height:auto!important;max-height:112mm;object-fit:contain;break-inside:avoid;page-break-inside:avoid}.details .psi-sheet-image-block{break-inside:avoid;page-break-inside:avoid}.details table{width:100%!important;max-width:100%!important;border-collapse:collapse;font-size:7.5pt}.details tr{break-inside:avoid;page-break-inside:avoid}.details th,.details td{border:1px solid #bcc9d3;padding:1.5mm;overflow-wrap:anywhere}.details .psi-sheet-wide-table-wrap{width:100%;overflow:visible;margin:5mm 0 7mm;break-before:page;page-break-before:always;break-inside:avoid;page-break-inside:avoid}.details table.psi-sheet-wide-table{table-layout:fixed!important;width:100%!important;font-size:6.2pt!important;line-height:1.05!important;break-inside:avoid!important;page-break-inside:avoid!important}.details table.psi-sheet-wide-table .psi-sheet-wide-header-row>*{height:36mm!important;background:#0b477e!important;color:#fff!important;font-weight:700!important;padding:.8mm!important;vertical-align:bottom!important;text-align:center!important;overflow:visible!important}.details table.psi-sheet-wide-table .psi-sheet-wide-header-row>*:first-child{width:29%!important;height:auto!important;writing-mode:horizontal-tb!important;transform:none!important;text-align:left!important;vertical-align:middle!important;padding:1.5mm!important;font-size:6.8pt!important}.details table.psi-sheet-wide-table .psi-sheet-wide-header-row>*:not(:first-child){writing-mode:vertical-rl!important;transform:rotate(180deg)!important;white-space:normal!important;font-size:5.5pt!important;line-height:1!important}.details table.psi-sheet-wide-table .psi-sheet-wide-data-row>*:first-child{width:29%!important;text-align:left!important;font-size:6.3pt!important;font-weight:600!important;color:#253b50!important;padding:1.15mm!important}.details table.psi-sheet-wide-table .psi-sheet-wide-data-row>*:not(:first-child){text-align:center!important;padding:.7mm .25mm!important;color:#16834c!important;font-size:7pt!important;font-weight:700!important}.details table.psi-sheet-wide-table .psi-sheet-wide-data-row:nth-child(even)>*{background:#f7f9fb}.details a{color:#0e68b9;text-decoration:none}.psi-sheet-wide-table-note{margin:4mm 0 7mm;padding:4mm 5mm;border:1px solid #cfe0ef;border-left:4px solid #0e68b9;border-radius:2mm;background:#f5f9fc;break-inside:avoid;page-break-inside:avoid}.psi-sheet-wide-table-note strong{display:block;color:#123f6e;font-size:11pt;margin-bottom:1mm}.psi-sheet-wide-table-note span{display:block;color:#5d7183;font-size:9pt}.ftr{margin-top:9mm;padding-top:5mm;border-top:1px solid #cbd9e4;color:#5b6e80;font-size:8pt;break-inside:avoid;page-break-inside:avoid}.ftr .contact{display:flex;flex-wrap:wrap;justify-content:space-between;gap:3mm;color:#314a61}.url{margin-top:2mm;overflow-wrap:anywhere;color:#0e68b9}@media screen{body{padding:16px}.sheet{width:210mm;max-width:210mm;padding:10mm;box-shadow:0 0 0 1px #dde5eb}body.psi-pdf-export{padding:0!important}.psi-pdf-export .sheet{width:190mm!important;max-width:190mm!important;padding:0!important;box-shadow:none!important;margin:0 auto!important}}@media screen and (max-width:840px){.sheet{width:100%;max-width:210mm;padding:7mm}}@media print{.sheet{width:190mm;max-width:190mm}}';
    }

    function build() {
      var opts = collectOptions();
      var rows = '';
      if (opts.length) {
        opts.forEach(function (r) {
          rows += '<tr><th>' + esc(r.label) + '</th><td>' + esc(r.value) + '</td><td class="op">' + esc(r.price) + '</td></tr>';
        });
      } else {
        rows = '<tr><th>Configuration</th><td colspan="2">No configurable options detected on the page.</td></tr>';
      }

      var t = title();
      var p = livePrice();
      var cp = comparePrice();
      var img = heroImage();
      var logo = logoImage();
      var who = text(customer.value);
      var desc = details.checked ? descriptionHtml() : '';

      if (!opts.length) {
        status.textContent = 'The sheet opened, but no product options were detected. If this product should have options, wait for them to appear on the product page first.';
        status.classList.add('is-visible');
      } else {
        status.classList.remove('is-visible');
      }

      return '<div class="sheet"><header class="hdr"><div class="brand">' +
        (logo ? '<img src="' + esc(logo) + '" alt="PSI Water Filters">' : '<strong>PSI Water Filters</strong>') +
        '</div><div class="meta"><strong>Customer Product Sheet</strong><span>' + esc(auDate()) + '</span></div></header>' +
        '<main><section class="hero"><div class="photo">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(t) + '">' : '') + '</div>' +
        '<div><div class="eyebrow">Configured system</div><h1>' + esc(t) + '</h1>' +
        (sku() ? '<div class="sku">SKU: ' + esc(sku()) + '</div>' : '') +
        (who ? '<div class="prepared"><span>Prepared for</span><strong>' + esc(who) + '</strong></div>' : '') +
        '<div class="price"><span>Configured price</span><div><strong>' + esc(p || 'Price unavailable') + '</strong>' +
        (cp && cp !== p ? '<span class="compare">' + esc(cp) + '</span>' : '') +
        '</div><small>Price and options are read from the live product page at the time this sheet is created.</small></div></div></section>' +
        '<section class="cfg"><div class="ttl">Selected configuration</div><table><tbody>' + rows + '</tbody></table></section>' +
        (desc ? '<section class="details"><div class="ttl">Product information</div>' + desc + '</section>' : '') +
        '</main><footer class="ftr"><div class="contact"><strong>PSI Water Filters</strong><span>(03) 6344 4635</span></div>' +
        '<div class="url">' + esc(location.href.split('#')[0]) + '</div><p>Pricing and availability are current when this sheet is generated and may change. Please confirm before ordering.</p></footer></div>';
    }

    function safeFilePart(value) {
      return text(value)
        .replace(/[^a-z0-9]+/gi, '-')
        .replace(/^-+|-+$/g, '')
        .replace(/-{2,}/g, '-')
        .slice(0, 70) || 'Product';
    }

    function pdfFilename() {
      var d = new Date();
      var stamp = String(d.getFullYear()) + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0');
      var id = sku() || title();
      return 'PSI-' + safeFilePart(id) + '-Product-Sheet-' + stamp + '.pdf';
    }

    function waitForFrameImages() {
      return new Promise(function (resolve) {
        var doc;
        try { doc = frame.contentDocument; } catch (e) { resolve(); return; }
        if (!doc) { resolve(); return; }
        var imgs = Array.prototype.slice.call(doc.images || []);
        if (!imgs.length) { resolve(); return; }
        var remaining = imgs.length;
        var done = false;
        var timer = setTimeout(finish, 6000);
        function finish() {
          if (done) return;
          done = true;
          clearTimeout(timer);
          resolve();
        }
        imgs.forEach(function (img) {
          if (img.complete) {
            remaining--;
            if (remaining <= 0) finish();
          } else {
            var one = function () {
              img.removeEventListener('load', one);
              img.removeEventListener('error', one);
              remaining--;
              if (remaining <= 0) finish();
            };
            img.addEventListener('load', one);
            img.addEventListener('error', one);
          }
        });
        if (remaining <= 0) finish();
      });
    }

    function waitForFrameReady() {
      return new Promise(function (resolve, reject) {
        var started = Date.now();
        (function check() {
          try {
            var doc = frame.contentDocument;
            if (doc && doc.readyState === 'complete' && doc.querySelector('.sheet')) {
              resolve(doc);
              return;
            }
          } catch (e) {}
          if (Date.now() - started > 8000) {
            reject(new Error('Preview did not finish loading'));
            return;
          }
          setTimeout(check, 80);
        })();
      });
    }

    function waitForElementImages(root) {
      return new Promise(function (resolve) {
        if (!root) { resolve(); return; }
        var imgs = Array.prototype.slice.call(root.querySelectorAll('img'));
        if (!imgs.length) { resolve(); return; }
        var remaining = imgs.length;
        var done = false;
        var timer = setTimeout(finish, 6000);
        function finish() {
          if (done) return;
          done = true;
          clearTimeout(timer);
          resolve();
        }
        imgs.forEach(function (img) {
          if (img.complete && img.naturalWidth) {
            remaining--;
            if (remaining <= 0) finish();
            return;
          }
          var one = function () {
            img.removeEventListener('load', one);
            img.removeEventListener('error', one);
            remaining--;
            if (remaining <= 0) finish();
          };
          img.addEventListener('load', one);
          img.addEventListener('error', one);
        });
        if (remaining <= 0) finish();
      });
    }

    function pdfCss() {
      return '#psi-sheet-export-host{width:190mm!important;max-width:190mm!important;margin:0!important;padding:0!important;background:#fff!important;color:#172839!important;font-family:Arial,Helvetica,sans-serif!important;font-size:10.5pt!important;line-height:1.45!important;-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}' +
        '#psi-sheet-export-host,#psi-sheet-export-host *{box-sizing:border-box!important}' +
        '#psi-sheet-export-host .sheet{width:190mm!important;max-width:190mm!important;margin:0!important;padding:0!important;background:#fff!important;box-shadow:none!important}' +
        '#psi-sheet-export-host .hdr{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:20px!important;padding:0 0 7mm!important;border-bottom:2px solid #0e68b9!important;break-inside:avoid!important;page-break-inside:avoid!important}' +
        '#psi-sheet-export-host .brand img{display:block!important;max-width:58mm!important;max-height:17mm!important;width:auto!important;height:auto!important}' +
        '#psi-sheet-export-host .brand strong{font-size:19pt!important;color:#0e68b9!important}' +
        '#psi-sheet-export-host .meta{text-align:right!important}' +
        '#psi-sheet-export-host .meta strong{display:block!important;color:#0e68b9!important;font-size:11pt!important}' +
        '#psi-sheet-export-host .meta span{color:#687887!important;font-size:9pt!important}' +
        '#psi-sheet-export-host .hero{display:grid!important;grid-template-columns:44% 56%!important;gap:8mm!important;padding:9mm 0 7mm!important;break-inside:avoid!important;page-break-inside:avoid!important}' +
        '#psi-sheet-export-host .photo{min-height:90mm!important;display:flex!important;align-items:center!important;justify-content:center!important;background:#f3f7fa!important;border:1px solid #d9e4ec!important;border-radius:3mm!important;overflow:hidden!important}' +
        '#psi-sheet-export-host .photo img{display:block!important;max-width:100%!important;max-height:100mm!important;width:auto!important;height:auto!important;object-fit:contain!important}' +
        '#psi-sheet-export-host .eyebrow{color:#0e68b9!important;font-size:9pt!important;font-weight:700!important;text-transform:uppercase!important;letter-spacing:.08em!important;margin-bottom:2mm!important}' +
        '#psi-sheet-export-host h1{font-size:22pt!important;line-height:1.12!important;margin:0 0 3mm!important;color:#123f6e!important;font-weight:700!important}' +
        '#psi-sheet-export-host .sku{color:#627384!important;margin-bottom:4mm!important}' +
        '#psi-sheet-export-host .prepared{border-top:1px solid #d9e4ec!important;padding-top:4mm!important;margin-top:4mm!important}' +
        '#psi-sheet-export-host .prepared span{display:block!important;font-size:8.5pt!important;color:#708191!important}' +
        '#psi-sheet-export-host .prepared strong{display:block!important;font-size:13pt!important;color:#24394d!important;margin-top:1mm!important}' +
        '#psi-sheet-export-host .price{margin-top:5mm!important;padding:5mm!important;background:#eef6fd!important;border-left:4px solid #0e68b9!important;border-radius:2mm!important;break-inside:avoid!important;page-break-inside:avoid!important}' +
        '#psi-sheet-export-host .price>span{display:block!important;color:#53697e!important;font-size:9pt!important;font-weight:700!important;text-transform:uppercase!important}' +
        '#psi-sheet-export-host .price strong{font-size:25pt!important;color:#0e68b9!important}' +
        '#psi-sheet-export-host .compare{margin-left:3mm!important;color:#8090a0!important;text-decoration:line-through!important}' +
        '#psi-sheet-export-host .price small{display:block!important;color:#5f7181!important;font-size:8pt!important}' +
        '#psi-sheet-export-host .ttl{font-size:14pt!important;font-weight:700!important;color:#123f6e!important;padding-bottom:2mm!important;margin-bottom:3mm!important;border-bottom:1px solid #cfdde8!important;break-after:avoid!important;page-break-after:avoid!important}' +
        '#psi-sheet-export-host .cfg{break-inside:avoid!important;page-break-inside:avoid!important;margin-bottom:8mm!important}' +
        '#psi-sheet-export-host .cfg table{width:100%!important;border-collapse:collapse!important;table-layout:fixed!important}' +
        '#psi-sheet-export-host .cfg tr{break-inside:avoid!important;page-break-inside:avoid!important}' +
        '#psi-sheet-export-host .cfg th,#psi-sheet-export-host .cfg td{padding:3mm 3.5mm!important;border-bottom:1px solid #e1e8ee!important;vertical-align:top!important;font-size:10.5pt!important;line-height:1.35!important}' +
        '#psi-sheet-export-host .cfg th{width:28%!important;text-align:left!important;color:#2e455b!important;background:#f7f9fb!important;font-weight:700!important}' +
        '#psi-sheet-export-host .cfg td:nth-child(2){width:54%!important}' +
        '#psi-sheet-export-host .op{width:18%!important;text-align:right!important;font-weight:700!important;color:#0e68b9!important;white-space:nowrap!important}' +
        '#psi-sheet-export-host .details{margin-top:7mm!important}' +
        '#psi-sheet-export-host .details h1{font-size:18pt!important;color:#123f6e!important}' +
        '#psi-sheet-export-host .details h2{font-size:15pt!important;color:#123f6e!important;margin:8mm 0 3mm!important;break-after:avoid!important;page-break-after:avoid!important}' +
        '#psi-sheet-export-host .details h3{font-size:12.5pt!important;color:#123f6e!important;margin:6mm 0 2mm!important;break-after:avoid!important;page-break-after:avoid!important}' +
        '#psi-sheet-export-host .details p,#psi-sheet-export-host .details li{font-size:10.5pt!important;line-height:1.45!important;color:#172839!important}' +
        '#psi-sheet-export-host .details img{display:block!important;max-width:100%!important;width:auto!important;height:auto!important;max-height:112mm!important;object-fit:contain!important;break-inside:avoid!important;page-break-inside:avoid!important}' +
        '#psi-sheet-export-host .details .psi-sheet-image-block{break-inside:avoid!important;page-break-inside:avoid!important}' +
        '#psi-sheet-export-host .details table{width:100%!important;max-width:100%!important;border-collapse:collapse!important;font-size:7.5pt!important}' +
        '#psi-sheet-export-host .details tr{break-inside:avoid!important;page-break-inside:avoid!important}' +
        '#psi-sheet-export-host .details th,#psi-sheet-export-host .details td{border:1px solid #bcc9d3!important;padding:1.5mm!important;overflow-wrap:anywhere!important}' +
        '#psi-sheet-export-host .details a{color:#0e68b9!important;text-decoration:none!important}' +
        '#psi-sheet-export-host .psi-sheet-wide-table-note{margin:4mm 0 7mm!important;padding:4mm 5mm!important;border:1px solid #cfe0ef!important;border-left:4px solid #0e68b9!important;border-radius:2mm!important;background:#f5f9fc!important;break-inside:avoid!important;page-break-inside:avoid!important}' +
        '#psi-sheet-export-host .psi-sheet-wide-table-note strong{display:block!important;color:#123f6e!important;font-size:11pt!important;margin-bottom:1mm!important}' +
        '#psi-sheet-export-host .psi-sheet-wide-table-note span{display:block!important;color:#5d7183!important;font-size:9pt!important}' +
        '#psi-sheet-export-host .ftr{margin-top:9mm!important;padding-top:5mm!important;border-top:1px solid #cbd9e4!important;color:#5b6e80!important;font-size:8pt!important;break-inside:avoid!important;page-break-inside:avoid!important}' +
        '#psi-sheet-export-host .ftr .contact{display:flex!important;flex-wrap:wrap!important;justify-content:space-between!important;gap:3mm!important;color:#314a61!important}' +
        '#psi-sheet-export-host .url{margin-top:2mm!important;overflow-wrap:anywhere!important;color:#0e68b9!important}';
    }

    function createExportDom() {
      var oldHost = document.getElementById('psi-sheet-export-host');
      if (oldHost && oldHost.parentNode) oldHost.parentNode.removeChild(oldHost);
      var oldStyle = document.getElementById('psi-sheet-export-style');
      if (oldStyle && oldStyle.parentNode) oldStyle.parentNode.removeChild(oldStyle);

      var style = document.createElement('style');
      style.id = 'psi-sheet-export-style';
      style.textContent = pdfCss();
      document.head.appendChild(style);

      var host = document.createElement('div');
      host.id = 'psi-sheet-export-host';
      host.setAttribute('aria-hidden', 'true');

      // html2canvas can return a completely blank canvas when the source node is
      // positioned thousands of pixels outside the viewport. Keep the export copy
      // at a real viewport coordinate and place it just underneath our modal instead.
      // It remains covered by the modal while the PDF is being created.
      host.style.position = 'fixed';
      host.style.left = '0';
      host.style.top = '0';
      host.style.zIndex = '999998';
      host.style.width = '190mm';
      host.style.maxWidth = '190mm';
      host.style.margin = '0';
      host.style.padding = '0';
      host.style.background = '#ffffff';
      host.style.pointerEvents = 'none';
      host.style.overflow = 'visible';

      // Use the exact DOM already shown in the preview where possible. This keeps
      // the PDF and preview in step and avoids rebuilding a slightly different copy.
      var previewSheet = null;
      try {
        previewSheet = frame.contentDocument && frame.contentDocument.querySelector('.sheet');
      } catch (e) {}

      if (previewSheet) {
        host.appendChild(previewSheet.cloneNode(true));
      } else {
        host.innerHTML = build();
      }

      document.body.appendChild(host);

      return { host: host, style: style, source: host };
    }

    function jsPdfCtor() {
      return window.jspdf && window.jspdf.jsPDF ? window.jspdf.jsPDF : null;
    }

    function absoluteUrl(value) {
      value = text(value);
      if (!value) return '';
      try { return new URL(value, location.href).href; }
      catch (e) { return value; }
    }

    function loadImageAsJpeg(url) {
      url = absoluteUrl(url);
      if (!url) return Promise.resolve(null);

      return fetch(url, { mode: 'cors', credentials: 'omit', cache: 'force-cache' })
        .then(function (response) {
          if (!response.ok) throw new Error('Image HTTP ' + response.status);
          return response.blob();
        })
        .then(function (blob) {
          return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () { resolve(reader.result); };
            reader.onerror = function () { reject(new Error('Image could not be read')); };
            reader.readAsDataURL(blob);
          });
        })
        .then(function (dataUrl) {
          return new Promise(function (resolve, reject) {
            var image = new Image();
            image.onload = function () {
              try {
                var maxSide = 1800;
                var naturalW = Math.max(1, image.naturalWidth || image.width || 1);
                var naturalH = Math.max(1, image.naturalHeight || image.height || 1);
                var scale = Math.min(1, maxSide / Math.max(naturalW, naturalH));
                var canvas = document.createElement('canvas');
                canvas.width = Math.max(1, Math.round(naturalW * scale));
                canvas.height = Math.max(1, Math.round(naturalH * scale));
                var ctx = canvas.getContext('2d');
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                resolve({
                  data: canvas.toDataURL('image/jpeg', 0.9),
                  width: naturalW,
                  height: naturalH
                });
              } catch (err) { reject(err); }
            };
            image.onerror = function () { reject(new Error('Image could not be decoded')); };
            image.src = dataUrl;
          });
        })
        .catch(function (err) {
          console.warn('[PSI Product Sheet] Image skipped in PDF:', url, err);
          return null;
        });
    }

    function productDetailBlocks() {
      if (!details.checked) return [];
      var html = descriptionHtml();
      if (!html) return [];

      var holder = document.createElement('div');
      holder.innerHTML = html;
      var nodes = holder.querySelectorAll('h1,h2,h3,h4,p,ul,ol,table,img,.psi-sheet-wide-table-note');
      var blocks = [];
      var productTitle = text(title()).toLowerCase();

      Array.prototype.forEach.call(nodes, function (node) {
        if (node.closest && node.closest('table') && node.tagName !== 'TABLE') return;
        if (node.closest && node.closest('.psi-sheet-wide-table-note') && !node.classList.contains('psi-sheet-wide-table-note')) return;

        var tag = (node.tagName || '').toUpperCase();
        if (/^H[1-4]$/.test(tag)) {
          var heading = text(node.textContent);
          if (!heading) return;
          if (heading.toLowerCase() === productTitle && blocks.length === 0) return;
          blocks.push({ type: 'heading', level: Number(tag.charAt(1)), text: heading });
          return;
        }

        if (tag === 'P') {
          var para = text(node.textContent);
          if (para) blocks.push({ type: 'paragraph', text: para });
          return;
        }

        if (tag === 'UL' || tag === 'OL') {
          var items = [];
          Array.prototype.forEach.call(node.children || [], function (li) {
            if ((li.tagName || '').toUpperCase() === 'LI') {
              var item = text(li.textContent);
              if (item) items.push(item);
            }
          });
          if (items.length) blocks.push({ type: 'list', ordered: tag === 'OL', items: items });
          return;
        }

        if (tag === 'IMG') {
          var src = node.currentSrc || node.src || node.getAttribute('data-src') || node.getAttribute('data-original') || '';
          if (src) blocks.push({ type: 'image', src: absoluteUrl(src), alt: text(node.alt) });
          return;
        }

        if (node.classList && node.classList.contains('psi-sheet-wide-table-note')) {
          blocks.push({ type: 'note', text: text(node.textContent) || 'The full comparison chart is available on the live product page.' });
          return;
        }

        if (tag === 'TABLE') {
          var rows = [];
          var maxCols = 0;
          Array.prototype.forEach.call(node.rows || [], function (row) {
            var cells = [];
            Array.prototype.forEach.call(row.cells || [], function (cell) { cells.push(text(cell.textContent)); });
            if (cells.length) rows.push(cells);
            maxCols = Math.max(maxCols, cells.length);
          });
          if (rows.length) {
            blocks.push({ type: 'table', rows: rows, cols: maxCols, wide: maxCols > 7 });
          }
        }
      });

      return blocks;
    }

    function addImageFitted(doc, image, x, y, w, h) {
      if (!image || !image.data) return;
      var ratio = image.width / image.height;
      var boxRatio = w / h;
      var drawW = w;
      var drawH = h;
      if (ratio > boxRatio) drawH = w / ratio;
      else drawW = h * ratio;
      var drawX = x + (w - drawW) / 2;
      var drawY = y + (h - drawH) / 2;
      doc.addImage(image.data, 'JPEG', drawX, drawY, drawW, drawH, undefined, 'FAST');
    }

    function rgb(hex) {
      hex = String(hex || '').replace('#', '');
      if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
      var value = parseInt(hex || '000000', 16);
      return [(value >> 16) & 255, (value >> 8) & 255, value & 255];
    }

    function setTextColour(doc, hex) {
      var c = rgb(hex); doc.setTextColor(c[0], c[1], c[2]);
    }

    function setFillColour(doc, hex) {
      var c = rgb(hex); doc.setFillColor(c[0], c[1], c[2]);
    }

    function setDrawColour(doc, hex) {
      var c = rgb(hex); doc.setDrawColor(c[0], c[1], c[2]);
    }

    function pdfSafeText(value) {
      return text(value)
        .replace(/[\u2018\u2019]/g, "'")
        .replace(/[\u201c\u201d\u2033]/g, '"')
        .replace(/\u2032/g, "'")
        .replace(/[\u2013\u2014]/g, ' - ')
        .replace(/\u00d7/g, ' x ')
        .replace(/\u2026/g, '...')
        .replace(/\u00a0/g, ' ')
        .replace(/[\u200b-\u200d\ufeff]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function wrappedLines(doc, value, width) {
      return doc.splitTextToSize(pdfSafeText(value), Math.max(8, width));
    }

    function drawTextBlock(doc, value, x, y, width, opts) {
      opts = opts || {};
      var size = opts.size || 10;
      var colour = opts.colour || '#172839';
      var style = opts.style || 'normal';
      var lineHeight = opts.lineHeight || 1.3;
      doc.setFont('helvetica', style);
      doc.setFontSize(size);
      setTextColour(doc, colour);
      var lines = wrappedLines(doc, value, width);
      doc.text(lines, x, y, { baseline: 'top', lineHeightFactor: lineHeight });
      return y + lines.length * size * 0.3528 * lineHeight;
    }

    function drawPdfPageHeader(doc, state) {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      setTextColour(doc, '#0e68b9');
      doc.text('PSI Water Filters', state.margin, 11);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      setTextColour(doc, '#687887');
      doc.text('Customer Product Sheet', state.pageW - state.margin, 11, { align: 'right' });
      setDrawColour(doc, '#cbd9e4');
      doc.setLineWidth(0.3);
      doc.line(state.margin, 15, state.pageW - state.margin, 15);
      state.y = 21;
    }

    function ensurePdfSpace(doc, state, needed) {
      if (state.y + needed <= state.bottom) return;
      doc.addPage();
      drawPdfPageHeader(doc, state);
    }

    function drawSectionTitle(doc, state, label) {
      ensurePdfSpace(doc, state, 12);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(13.5);
      setTextColour(doc, '#123f6e');
      doc.text(pdfSafeText(label), state.margin, state.y, { baseline: 'top' });
      state.y += 7;
      setDrawColour(doc, '#cfdde8');
      doc.setLineWidth(0.35);
      doc.line(state.margin, state.y, state.pageW - state.margin, state.y);
      state.y += 5;
    }

    function drawConfigurationTable(doc, state, opts) {
      var x = state.margin;
      var totalW = state.contentW;
      var labelW = 50;
      var priceW = 30;
      var valueW = totalW - labelW - priceW;

      opts.forEach(function (row) {
        doc.setFontSize(9.5);
        doc.setFont('helvetica', 'bold');
        var labelLines = wrappedLines(doc, row.label, labelW - 7);
        doc.setFont('helvetica', 'normal');
        var valueLines = wrappedLines(doc, row.value, valueW - 7);
        doc.setFont('helvetica', 'bold');
        var priceLines = wrappedLines(doc, row.price || '', priceW - 5);
        var lineCount = Math.max(labelLines.length, valueLines.length, priceLines.length, 1);
        var rowH = Math.max(11, 5.0 + lineCount * 4.2);
        ensurePdfSpace(doc, state, rowH + 1);

        setFillColour(doc, '#f7f9fb');
        doc.rect(x, state.y, labelW, rowH, 'F');
        setDrawColour(doc, '#dbe5ec');
        doc.setLineWidth(0.25);
        doc.line(x, state.y + rowH, x + totalW, state.y + rowH);

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9.5);
        setTextColour(doc, '#2e455b');
        doc.text(labelLines, x + 3.5, state.y + 3.5, { baseline: 'top', lineHeightFactor: 1.2 });

        doc.setFont('helvetica', 'normal');
        setTextColour(doc, '#172839');
        doc.text(valueLines, x + labelW + 3.5, state.y + 3.5, { baseline: 'top', lineHeightFactor: 1.2 });

        if (row.price) {
          doc.setFont('helvetica', 'bold');
          setTextColour(doc, '#0e68b9');
          doc.text(priceLines, x + totalW - 3.5, state.y + 3.5, { align: 'right', baseline: 'top', lineHeightFactor: 1.2 });
        }
        state.y += rowH;
      });
      state.y += 6;
    }

    function drawSmallTable(doc, state, block) {
      var cols = Math.max(1, block.cols || 1);
      var colW = state.contentW / cols;
      var fontSize = cols >= 6 ? 6.7 : (cols >= 4 ? 7.5 : 8.5);
      block.rows.forEach(function (row, rowIndex) {
        doc.setFontSize(fontSize);
        var wrapped = [];
        var maxLines = 1;
        for (var c = 0; c < cols; c++) {
          doc.setFont('helvetica', rowIndex === 0 ? 'bold' : 'normal');
          var lines = wrappedLines(doc, row[c] || '', colW - 4);
          wrapped.push(lines);
          maxLines = Math.max(maxLines, lines.length);
        }
        var rowH = Math.max(8, 3 + maxLines * fontSize * 0.3528 * 1.15);
        ensurePdfSpace(doc, state, rowH + 1);
        if (rowIndex === 0) {
          setFillColour(doc, '#eef6fd');
          doc.rect(state.margin, state.y, state.contentW, rowH, 'F');
        }
        for (var i = 0; i < cols; i++) {
          setDrawColour(doc, '#b9c9d6');
          doc.rect(state.margin + i * colW, state.y, colW, rowH);
          doc.setFont('helvetica', rowIndex === 0 ? 'bold' : 'normal');
          setTextColour(doc, '#172839');
          doc.text(wrapped[i], state.margin + i * colW + 2, state.y + 2.5, { baseline: 'top', lineHeightFactor: 1.15 });
        }
        state.y += rowH;
      });
      state.y += 5;
    }


    function drawTick(doc, cx, cy) {
      setDrawColour(doc, '#16834c');
      doc.setLineWidth(0.65);
      doc.line(cx - 1.7, cy, cx - 0.3, cy + 1.5);
      doc.line(cx - 0.3, cy + 1.5, cx + 2.1, cy - 1.8);
      doc.setLineWidth(0.25);
    }

    function drawWideComparisonTable(doc, state, block) {
      var cols = Math.max(2, block.cols || 2);
      var rows = block.rows || [];
      if (!rows.length) return;

      var firstW = 48;
      var otherW = (state.contentW - firstW) / (cols - 1);
      var headerH = 46;
      var rowH = 6.2;
      var needed = 12 + headerH + Math.max(0, rows.length - 1) * rowH + 8;

      if (state.y + needed > state.bottom) {
        doc.addPage();
        drawPdfPageHeader(doc, state);
      }
      drawSectionTitle(doc, state, 'Cartridge Comparison');

      var x = state.margin;
      var y = state.y;
      setFillColour(doc, '#0b477e');
      setDrawColour(doc, '#183b59');
      doc.rect(x, y, state.contentW, headerH, 'FD');

      // First header cell.
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7.2);
      setTextColour(doc, '#ffffff');
      var firstHeader = wrappedLines(doc, (rows[0] && rows[0][0]) || 'Reduction Claim', firstW - 5);
      doc.text(firstHeader, x + 2.5, y + headerH / 2 - 2, { baseline: 'middle', lineHeightFactor: 1.1 });
      setDrawColour(doc, '#183b59');
      doc.rect(x, y, firstW, headerH);

      // Rotated product headings keep all columns readable on portrait A4.
      for (var c = 1; c < cols; c++) {
        var cellX = x + firstW + (c - 1) * otherW;
        doc.rect(cellX, y, otherW, headerH);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(5.25);
        setTextColour(doc, '#ffffff');
        var header = pdfSafeText((rows[0] && rows[0][c]) || '');
        if (header) {
          var maxChars = 34;
          if (header.length > maxChars) header = header.slice(0, maxChars - 1) + '.';
          doc.text(header, cellX + otherW / 2 + 1.2, y + headerH - 2.5, { angle: 90, baseline: 'middle' });
        }
      }
      y += headerH;

      for (var r = 1; r < rows.length; r++) {
        var fill = r % 2 === 0 ? '#f7f9fb' : '#ffffff';
        setFillColour(doc, fill);
        doc.rect(x, y, state.contentW, rowH, 'F');

        setDrawColour(doc, '#9fb0be');
        doc.rect(x, y, firstW, rowH);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(6.6);
        setTextColour(doc, '#253b50');
        var claim = wrappedLines(doc, (rows[r] && rows[r][0]) || '', firstW - 4);
        doc.text(claim.slice(0, 1), x + 2, y + 1.5, { baseline: 'top' });

        for (var cc = 1; cc < cols; cc++) {
          var cx = x + firstW + (cc - 1) * otherW;
          doc.rect(cx, y, otherW, rowH);
          var raw = text((rows[r] && rows[r][cc]) || '');
          if (/^[\u2713\u2714✔✓]+$/.test(raw.replace(/\s/g, ''))) {
            drawTick(doc, cx + otherW / 2, y + rowH / 2);
          } else if (raw) {
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(5.8);
            setTextColour(doc, '#172839');
            doc.text(pdfSafeText(raw).slice(0, 5), cx + otherW / 2, y + rowH / 2 + 0.6, { align: 'center', baseline: 'middle' });
          }
        }
        y += rowH;
      }
      state.y = y + 6;
    }

    async function drawDetailImages(doc, state, imageBlocks) {
      var loaded = await Promise.all(imageBlocks.map(function (b) { return loadImageAsJpeg(b.src); }));
      loaded = loaded.filter(Boolean);
      if (!loaded.length) return;

      var gap = 5;
      var cols = loaded.length > 1 ? 2 : 1;
      var boxW = cols === 2 ? (state.contentW - gap) / 2 : Math.min(state.contentW, 105);
      var boxH = cols === 2 ? 72 : 86;
      ensurePdfSpace(doc, state, boxH + 8);
      var startX = cols === 1 ? state.margin + (state.contentW - boxW) / 2 : state.margin;

      loaded.forEach(function (image, index) {
        var x = startX + (cols === 2 ? index * (boxW + gap) : 0);
        setFillColour(doc, '#f3f7fa');
        setDrawColour(doc, '#d9e4ec');
        doc.roundedRect(x, state.y, boxW, boxH, 2, 2, 'FD');
        addImageFitted(doc, image, x + 2, state.y + 2, boxW - 4, boxH - 4);
      });
      state.y += boxH + 7;
    }

    async function renderProductDetails(doc, state) {
      var blocks = productDetailBlocks();
      if (!blocks.length) return;

      doc.addPage();
      drawPdfPageHeader(doc, state);
      drawSectionTitle(doc, state, 'Product information');

      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        if (block.type === 'heading') {
          if (/cartridge\s+comparison/i.test(block.text || '') && blocks[i + 1] && blocks[i + 1].type === 'table' && blocks[i + 1].wide) {
            continue;
          }
          var headingSize = block.level <= 1 ? 15 : (block.level === 2 ? 13 : 11.5);
          ensurePdfSpace(doc, state, 13);
          state.y += block.level <= 2 ? 3 : 2;
          state.y = drawTextBlock(doc, block.text, state.margin, state.y, state.contentW, {
            size: headingSize, colour: '#123f6e', style: 'bold', lineHeight: 1.15
          });
          state.y += 3;
          continue;
        }

        if (block.type === 'paragraph') {
          doc.setFontSize(10);
          var lines = wrappedLines(doc, block.text, state.contentW);
          var needed = Math.max(7, lines.length * 4.3 + 2);
          ensurePdfSpace(doc, state, needed);
          state.y = drawTextBlock(doc, block.text, state.margin, state.y, state.contentW, {
            size: 10, colour: '#172839', style: 'normal', lineHeight: 1.28
          });
          state.y += 3;
          continue;
        }

        if (block.type === 'list') {
          for (var li = 0; li < block.items.length; li++) {
            var prefix = block.ordered ? (li + 1) + '. ' : '• ';
            doc.setFontSize(10);
            var listLines = wrappedLines(doc, block.items[li], state.contentW - 8);
            var listNeed = Math.max(6, listLines.length * 4.45 + 1);
            ensurePdfSpace(doc, state, listNeed);
            doc.setFont('helvetica', 'normal');
            setTextColour(doc, '#172839');
            doc.text(prefix, state.margin + 2, state.y, { baseline: 'top' });
            doc.text(listLines, state.margin + 8, state.y, { baseline: 'top', lineHeightFactor: 1.25 });
            state.y += listLines.length * 4.45 + 1;
          }
          state.y += 3;
          continue;
        }

        if (block.type === 'note') {
          doc.setFontSize(9.2);
          var noteLines = wrappedLines(doc, block.text, state.contentW - 12);
          var noteH = Math.max(16, 8 + noteLines.length * 4.2);
          ensurePdfSpace(doc, state, noteH + 5);
          setFillColour(doc, '#f5f9fc');
          setDrawColour(doc, '#cfe0ef');
          doc.roundedRect(state.margin, state.y, state.contentW, noteH, 2, 2, 'FD');
          setFillColour(doc, '#0e68b9');
          doc.rect(state.margin, state.y, 2.2, noteH, 'F');
          doc.setFont('helvetica', 'bold');
          setTextColour(doc, '#123f6e');
          doc.text(noteLines, state.margin + 6, state.y + 4, { baseline: 'top', lineHeightFactor: 1.25 });
          state.y += noteH + 5;
          continue;
        }

        if (block.type === 'table') {
          if (block.wide) drawWideComparisonTable(doc, state, block);
          else drawSmallTable(doc, state, block);
          continue;
        }

        if (block.type === 'image') {
          var run = [block];
          while (run.length < 2 && i + 1 < blocks.length && blocks[i + 1].type === 'image') {
            run.push(blocks[++i]);
          }
          await drawDetailImages(doc, state, run);
        }
      }
    }

    function addPdfFooters(doc, state) {
      var pageCount = doc.getNumberOfPages();
      for (var page = 1; page <= pageCount; page++) {
        doc.setPage(page);
        setDrawColour(doc, '#d7e2ea');
        doc.setLineWidth(0.25);
        doc.line(state.margin, state.pageH - 12, state.pageW - state.margin, state.pageH - 12);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7.5);
        setTextColour(doc, '#65798b');
        doc.text('PSI Water Filters  •  (03) 6344 4635  •  psifilters.com.au', state.margin, state.pageH - 7);
        doc.text('Page ' + page + ' of ' + pageCount, state.pageW - state.margin, state.pageH - 7, { align: 'right' });
      }
    }

    async function generateNativePdf() {
      var Ctor = jsPdfCtor();
      if (!Ctor) throw new Error('PDF library did not load');

      var doc = new Ctor({ unit: 'mm', format: 'a4', orientation: 'portrait', compress: true });
      var state = {
        pageW: 210,
        pageH: 297,
        margin: 12,
        contentW: 186,
        bottom: 278,
        y: 12
      };

      var logoPromise = loadImageAsJpeg(logoImage());
      var heroPromise = loadImageAsJpeg(heroImage());
      var images = await Promise.all([logoPromise, heroPromise]);
      var logo = images[0];
      var hero = images[1];

      // Page 1 header
      if (logo) addImageFitted(doc, logo, state.margin, 11, 58, 17);
      else {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(20);
        setTextColour(doc, '#0e68b9');
        doc.text('PSI WATER FILTERS', state.margin, 17);
      }
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10.5);
      setTextColour(doc, '#0e68b9');
      doc.text('Customer Product Sheet', state.pageW - state.margin, 13, { align: 'right' });
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8.5);
      setTextColour(doc, '#687887');
      doc.text(auDate(), state.pageW - state.margin, 18, { align: 'right' });
      setDrawColour(doc, '#0e68b9');
      doc.setLineWidth(0.55);
      doc.line(state.margin, 33, state.pageW - state.margin, 33);

      // Hero panel
      var heroY = 42;
      var imageX = state.margin;
      var imageW = 82;
      var imageH = 91;
      setFillColour(doc, '#f3f7fa');
      setDrawColour(doc, '#d9e4ec');
      doc.roundedRect(imageX, heroY, imageW, imageH, 2.5, 2.5, 'FD');
      if (hero) addImageFitted(doc, hero, imageX + 2, heroY + 2, imageW - 4, imageH - 4);

      var rightX = imageX + imageW + 9;
      var rightW = state.pageW - state.margin - rightX;
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8.5);
      setTextColour(doc, '#0e68b9');
      doc.text('CONFIGURED SYSTEM', rightX, heroY + 2, { baseline: 'top' });

      var titleY = heroY + 10;
      titleY = drawTextBlock(doc, title(), rightX, titleY, rightW, { size: 21, colour: '#123f6e', style: 'bold', lineHeight: 1.08 });
      titleY += 2;
      if (sku()) titleY = drawTextBlock(doc, 'SKU: ' + sku(), rightX, titleY, rightW, { size: 9.2, colour: '#627384', lineHeight: 1.2 });

      var who = text(customer.value);
      if (who) {
        titleY += 3;
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7.8);
        setTextColour(doc, '#708191');
        doc.text('Prepared for', rightX, titleY, { baseline: 'top' });
        titleY += 4;
        titleY = drawTextBlock(doc, who, rightX, titleY, rightW, { size: 11.5, colour: '#24394d', style: 'bold', lineHeight: 1.15 });
      }

      var priceY = Math.max(heroY + 50, titleY + 4);
      var priceH = 36;
      setFillColour(doc, '#eef6fd');
      doc.roundedRect(rightX, priceY, rightW, priceH, 2, 2, 'F');
      setFillColour(doc, '#0e68b9');
      doc.rect(rightX, priceY, 2.2, priceH, 'F');
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8.2);
      setTextColour(doc, '#53697e');
      doc.text('CONFIGURED PRICE', rightX + 6, priceY + 5, { baseline: 'top' });
      doc.setFontSize(22);
      setTextColour(doc, '#0e68b9');
      doc.text(livePrice() || 'Price unavailable', rightX + 6, priceY + 12, { baseline: 'top' });
      var cp = comparePrice();
      if (cp && cp !== livePrice()) {
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8.5);
        setTextColour(doc, '#8090a0');
        doc.text(cp, rightX + rightW - 4, priceY + 16, { align: 'right', baseline: 'top' });
      }
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7.3);
      setTextColour(doc, '#5f7181');
      var priceNote = doc.splitTextToSize('Price and options are read from the live product page at the time this sheet is created.', rightW - 12);
      doc.text(priceNote, rightX + 6, priceY + 25, { baseline: 'top', lineHeightFactor: 1.15 });

      state.y = heroY + imageH + 10;
      drawSectionTitle(doc, state, 'Selected configuration');
      var opts = collectOptions();
      if (!opts.length) opts = [{ label: 'Configuration', value: 'No configurable options detected on the page.', price: '' }];
      drawConfigurationTable(doc, state, opts);

      await renderProductDetails(doc, state);
      addPdfFooters(doc, state);
      doc.save(pdfFilename());
    }

    function downloadPdf() {
      if (!jsPdfCtor()) {
        status.textContent = 'The PDF component did not load. Please refresh the page and try again. Printing is still available.';
        status.classList.add('is-visible');
        return;
      }

      downloadBtn.disabled = true;
      printBtn.disabled = true;
      downloadBtn.textContent = 'Creating PDF…';
      status.textContent = 'Creating your PDF…';
      status.classList.add('is-visible');

      generateNativePdf()
        .then(function () {
          status.textContent = 'PDF downloaded.';
          setTimeout(function () { status.classList.remove('is-visible'); }, 2200);
        })
        .catch(function (err) {
          console.error('[PSI Product Sheet] PDF download failed', err);
          var detail = err && err.message ? String(err.message) : '';
          status.textContent = 'The PDF could not be created' + (detail ? ' (' + detail.slice(0, 140) + ')' : '') + '. Printing is still available.';
          status.classList.add('is-visible');
        })
        .finally(function () {
          downloadBtn.disabled = false;
          printBtn.disabled = false;
          downloadBtn.textContent = 'Download PDF';
        });
    }

    function documentHtml() {
      return '<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>' + esc(title()) + ' - Product Sheet</title><style>' + printCss() + '</style></head><body>' + build() + '</body></html>';
    }

    function render() {
      return new Promise(function (resolve) {
        frame.onload = function () {
          try {
            var doc = frame.contentDocument;
            var h = Math.max(1080, doc.documentElement.scrollHeight, doc.body ? doc.body.scrollHeight : 0);
            frame.style.height = Math.min(h + 8, 7000) + 'px';
          } catch (e) {}
          resolve();
        };
        frame.srcdoc = documentHtml();
      });
    }

    function open(e) {
      if (e) e.preventDefault();
      lastFocused = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      render();
      setTimeout(function () { customer.focus(); }, 0);
    }

    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    document.addEventListener('click', function (e) {
      var target = e.target.closest ? e.target.closest('.psi-config-print') : null;
      if (target) open(e);
    });

    customer.addEventListener('input', render);
    details.addEventListener('change', render);
    closeBtn.addEventListener('click', close);
    downloadBtn.addEventListener('click', downloadPdf);
    printBtn.addEventListener('click', function () {
      printBtn.disabled = true;
      render().then(function () { return waitForFrameImages(); }).then(function () {
        try {
          frame.contentWindow.focus();
          frame.contentWindow.print();
        } catch (e) {
          status.textContent = 'The browser could not open the print dialog. Try again, or use Ctrl+P while the preview is open.';
          status.classList.add('is-visible');
        } finally {
          printBtn.disabled = false;
        }
      }).catch(function () {
        printBtn.disabled = false;
        status.textContent = 'The print preview was not ready. Please try Print again.';
        status.classList.add('is-visible');
      });
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  });
})();
